import React, { FC } from 'react';
import { useParams } from 'react-router-dom';

import { OrderDetails } from '../containers';

export const OrderDetailsPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const ids = id.split('/');

  return (
    <React.Fragment>
      {ids.map((id, index) => (
        <OrderDetails key={index} id={id} />
      ))}
    </React.Fragment>
  );
};
